var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-icon',{attrs:{"name":_vm.logoType,"maintainColor":_vm.useDefaultColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }